import type { TestGroupingGroup } from '@vedalib/editor/lib/elements'
import { FileUsageSource } from '@vedalib/editor/lib/files'
import { generateId } from '@vedalib/editor/lib/utils/id'
import { textToRtValue } from '@vedalib/rich-text'
import React, { useCallback } from 'react'

import { IRenderButtonAddItem } from 'components/uiKit/ArrayControl/types'
import Button from 'components/uiKit/Button'
import { KitSize } from 'components/uiKit/KitTypes'
import { t } from 'services/Translation'

const TestGroupingFormValueAddGroup: React.FC<IRenderButtonAddItem<TestGroupingGroup>> = ({
  onChange,
  array,
  name,
  max,
}) => {
  const handleAdd = useCallback(() => {
    const item: TestGroupingGroup = {
      value: generateId(),
      items: [],
      target: {
        label: textToRtValue(`${t('elements.grouping.tags.group')} ${array.length + 1}`),
        image: {
          source: FileUsageSource.file,
          id: '',
          accessibility: '',
        },
        overlay: null,
      },
    }
    onChange?.([...array, item], { command: 'add', item })
  }, [onChange, array])

  return (
    <Button
      disabled={Boolean(max && array.length >= max)}
      name={`${name}.addItem`}
      onClick={handleAdd}
      size={KitSize.L}
      fluid
    >
      {t('uiKit.button.add')}
    </Button>
  )
}

export default React.memo(TestGroupingFormValueAddGroup) as typeof TestGroupingFormValueAddGroup
